import {Toast, PullRefresh, Dialog} from 'vant';
import JsBarcode from "jsbarcode";

export default {

  data() {
    return {
      teamScoreList: [],
      loading: false,
      finished: false,
      length: 16,//村超球队数量
      memberId: 0,
      winShow: false,
      getShow: false,
      aTeamScoreList: [],
      bTeamScoreList: [],
      cTeamScoreList: [],
      dTeamScoreList: [],
      teamList: [],
    };
  },

  created() {
    this.memberId = this.$route.query.memberId
  },

  mounted() {

  },
  unmounted() {

  },
  methods: {
    onLoad () {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        this.$api.getScoreRankingList({
          params: {
            playId: 2,
          },
          success: function (res) {
            console.log(":::teamScoreList:", res)
            this.teamList = res.data;
            console.log(":::aTeamList:", this.teamList.aTeamList)
            this.teamScoreList = this.teamList.totalTeamList;
            this.aTeamScoreList = this.teamList.aTeamList;
            this.bTeamScoreList = this.teamList.bTeamList;
            this.cTeamScoreList = this.teamList.cTeamList;
            this.dTeamScoreList = this.teamList.dTeamList;
            // 加载状态结束
            this.loading = false;
          }.bind(this),
        })
        //数据全部加载完成
        if (this.teamList.aTeamList.length >= this.length/4) {
          this.finished = true;
        }
      }, 1000);
    },
    replayScore(){
      this.$api.getScoreRankingList({
        params: {
          playId: 2,
        },
        success: function (res) {
          console.log(":::teamScoreList:", res)
          this.teamList = res.data;
          console.log(":::aTeamList:", this.teamList.aTeamList)
          this.teamScoreList = this.teamList.totalTeamList;
          this.aTeamScoreList = this.teamList.aTeamList;
          this.bTeamScoreList = this.teamList.bTeamList;
          this.cTeamScoreList = this.teamList.cTeamList;
          this.dTeamScoreList = this.teamList.dTeamList;
        }.bind(this),
      })
    },
    addScoreWinLose(){
      this.winShow = true;
    },
    addScoreGetLose(){
      this.getShow = true;
    },
    submitTeamScore(item){
      console.log(":::item:", item)
      this.$api.submitTeamScore({
        params: {
          item: item,
        },
        success: function (res) {
          console.log(":::res:", res)
          Toast('积分更新成功');
        }.bind(this),
      })
    },
    submitTeamGetLose(item){
      console.log(":::item:", item)
      this.$api.submitTeamGetLose({
        params: {
          item: item,
        },
        success: function (res) {
          console.log(":::res:", res)
          Toast('名次更新成功');
        }.bind(this),
      })
    },
    // gotoPlayer(){
    //   this.$router.push({
    //     path: '/playScorePlayer'
    //   })
    // },
    // splitTeamScoreList(){
    //   for (let i = 0; i < this.teamScoreList.length; i ++) {
    //     if(this.teamScoreList[i].by2 == 'A'){
    //       this.teamScoreListA.push(this.teamScoreList[i]);
    //     }
    //     if(this.teamScoreList[i].by2 == 'B'){
    //       this.teamScoreListB.push(this.teamScoreList[i]);
    //     }
    //     console.log(":::teamScoreListA:", this.teamScoreListA);
    //     console.log(":::teamScoreListB:", this.teamScoreListB);
    //   }
    // }
  },
};
